/* @flow */
import type { Map } from 'immutable';
import {
  SAVE,
  DELETE,
  UPLOAD_REDACTION_FILE,
  FETCH_REDACTABLES,
} from './action-types.js';
import type { TermShape, FilesObject } from './types.js';

/* Dispatch an action to add a new redactable term */
export const addTerm = (term: TermShape): Object => ({
  type: SAVE,
  payload: term
});

/* Handle importing bulk terms from a JSON file */
export const importTermsFromFile = ({ files }: FilesObject): Object => ({
  type: UPLOAD_REDACTION_FILE,
  payload: files
});

/* Dispatch an action to delete a redactable term */
export const deleteTerm = (term: TermShape): Object => ({
  type: DELETE,
  payload: term
});

/* Get all redactables for a given report */
export const fetchRedactables = (report: Map<any, any>): Object => ({
  type: FETCH_REDACTABLES,
  payload: report
});



// WEBPACK FOOTER //
// ./src/app/modules/redaction/actions.js